export const contactsData = {
    email: 'muthyala.s@northeastern.edu',
    address: 'Boston, MA',

    sheetAPI: 'https://sheetdb.io/api/v1/6d5i71p2ne3mh'
}
